import type { HTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

const InlineCode = ({ className, ...props }: HTMLAttributes<HTMLSpanElement>) => {
  return (
    <span
      className={twMerge(
        "px-1 py-0.5 bg-neutral-500/10 dark:bg-neutral-500/20 rounded-md font-mono text-sm border border-solid border-border-default",
        className,
      )}
      {...props}
    />
  )
}

export default InlineCode
